<framework-action-dropdown
  [buttonStyle]="buttonStyle"
  [level]="level"
  [location]="location"
  [masterProject]="masterProject"
  [project]="project"
  [phase]="phase"
  [task]="task"
  [actions]="getSecondaryActions()"
>
</framework-action-dropdown>
